export const emptyFormForProductRespose = {
  id: null,
  productName: "",
  description: "",
  brand: "",
  modelNumber: "",

  currency: "ETB",
  productCondition: "NEW", // default

  categoryId: null,
  subCategoryId: null,

  dimensionUnit: "cm",
  weightUnit: "kg",

  returnPolicy: "",
  warrantyPeriod: "",
};

export const createEmptyVariant = () => ({
  id: null,
  sku: "",
  price: "",
  availableQuantity: "",
  weight: "",
  productCondition: "NEW",
  productStatus: "ACTIVE",
  isDefault: false,
  attributes: {},

  existingImages: [],
  newImages: [],
  previews: [],
  removedImageIds: [],
});
